import React from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";

const FAKE_DATA = [
  { year: "FY22", value: 0.27 },
  { year: "FY23", value: 0.28 },
  { year: "FY24", value: 0.31 },
  { year: "FY25", value: 0.31 },
];

const LINE_COLOR = "#09A3B3";

const AvgWaterIntensity = () => {
  const currentValue = 0.32;
  const previousValue = 0.32;
  const percentChange = 0.3;
  const compareYear = "FY24";

  return (
    <>
      <br />
      <h3 className="sub-title mt-4">Average Water Intensity: FY22 - FY25</h3>
      <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
        (kL / Occupied Bed Days)
      </p>

      <div className="card">
        <div className="card-body" style={{ position: "relative" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "12px",
              fontWeight: 600,
            }}
          >
            <span>{currentValue.toFixed(2)}</span>
            <span style={{ margin: "0 8px", color: "#999" }}>|</span>
            <span style={{ color: "#000" }}>▲{percentChange}%</span>
            <span style={{ color: "#666", fontWeight: 400, marginLeft: "6px" }}>
              vs {previousValue.toFixed(2)} in {compareYear}
            </span>
          </div>

          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={FAKE_DATA} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
              <CartesianGrid strokeDasharray="0" stroke="#e9ebf1" vertical={false} />
              <XAxis
                dataKey="year"
                stroke="#666"
                tick={{ fontSize: 12 }}
                axisLine={{ stroke: "#e9ebf1" }}
                tickLine={false}
              />
              <YAxis
                dataKey="value"
                stroke="#666"
                domain={[0, 0.35]}
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
                tickFormatter={(v) => v.toFixed(1)}
              />
              <Tooltip
                formatter={(value) => [value.toFixed(2), "Water Intensity"]}
                labelFormatter={(label) => label}
                contentStyle={{
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  borderRadius: "4px",
                  border: "none",
                }}
              />
              <Line
                type="monotone"
                dataKey="value"
                stroke={LINE_COLOR}
                strokeWidth={2}
                dot={{ r: 4, fill: LINE_COLOR, strokeWidth: 0 }}
                activeDot={{ r: 5, fill: LINE_COLOR }}
                connectNulls
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default AvgWaterIntensity;
